// extracted by mini-css-extract-plugin
export default {"heart":"style__heart___ggmVa","heartBeat":"style__heartBeat___ZkdR1","track":"style__track___C40HB","trace":"style__trace___eb0EW","heartTrace":"style__heartTrace___Q8qso"};